import { HttpConfigInterface } from "../interface/HttpConfigInterface";
import ResponseHelper from "@/utils/httpUtil/impl/ResponseHelper";
import { IResponse } from "@/utils/httpUtil/interface/ResponseHelper";
import { RequestConfig } from "@/utils/httpUtil/interface/RequestConfig";
import { extend } from "@utils/commonUtil";
import SentryUtil from "@/utils/sentryUtil";
import store from "../../../store";
import axios, { Method } from "axios";
import { getIsBudgetHealthProjectAtivitySystemPermissionSession } from "@utils/userStorage";
const qs = require("qs");
// import { getSession } from "@utils/localStorageUtil";
const handleParamsFn = function (params: any = {}) {
  const state = store.state;
  // console.log("阿斯蒂芬士大夫",state);
  let comtyId = "";
  let bId = "";
  if (store.state.version === "v2") {
    comtyId = state.comtyIdNew || "";
  } else if (store.state.version === "v1") {
    comtyId = state.comtyId || "";
    bId = params.bId || state.bId || "";
  }

  // const token = getSession("token");
  params = { ...params, ...{ bId } };
  if (comtyId && params.comtyId != "") {
    params.comtyId = params.communityId = params.comtyId || comtyId;
  }
  const BudgetHealthProjectAtivitySystemPermissionSession = getIsBudgetHealthProjectAtivitySystemPermissionSession();
  if (BudgetHealthProjectAtivitySystemPermissionSession) {
    params.healthServiceProjectId = BudgetHealthProjectAtivitySystemPermissionSession;
  }
  // params.type = "medicine";
  // params.operatorId = "5fb7a85e4576293d8762f4b6";
  // params.userId = "5fb7a85e4576293d8762f4b6";
  params.comtyType = "5";
  // console.log(params);
  return params;
};
export function createService(httpConfig: HttpConfigInterface): { service: any; request: (option: RequestConfig) => Promise<any> } {
  const responseHelper = new ResponseHelper(httpConfig.ErrorArray);
  const service = axios.create({
    baseURL: httpConfig.baseURL, // url = base url + request url
    withCredentials: httpConfig.withCredentials, // send cookies when cross-domain requests
    timeout: httpConfig.timeout, // request timeout
  });
  // eslint-disable-next-line
  const emptyFunction = function () {};

  function responseHandler(res: IResponse) {
    if (httpConfig.responseInterceptor) {
      if (httpConfig.responseInterceptor(res)) {
        return new Promise(emptyFunction);
      }
    }
    if (res.status) {
      return res;
    } else {
      return Promise.reject(res);
    }
  }
  // 请求拦截
  // request interceptor
  service.interceptors.request.use(
    (config: any) => {
      // console.log("config", config);
      // do something before request is sent
      httpConfig.requestInterceptor && httpConfig.requestInterceptor(config);
      return config;
    },
    (error: any) => {
      console.log("request-error:", error.response);
      SentryUtil.captureHttpError(error);
      const res = responseHelper.getResponseFromError(error.response);
      return responseHandler(res);
    }
  );
  // 响应拦截
  // response interceptor
  service.interceptors.response.use(
    (response: any): any => {
      const res = responseHelper.getResponse(response);
      return responseHandler(res);
    },
    (error: any) => {
      SentryUtil.captureHttpError(error);
      const res = responseHelper.getResponseFromError(error.response);
      return responseHandler(res);
    }
  );
  function request<T>(option: RequestConfig): Promise<T> {
    if (option.originalData === undefined) {
      option.originalData = true;
    }
    return service(option)
      .then((res: any): Promise<T> => {
        if (option.validator && option.validator(res) != true) {
          return Promise.reject(res);
        }
        if (option.originalData) {
          return Promise.resolve(res);
        } else {
          return Promise.resolve(res.data);
        }
      })
      .catch((err: IResponse): Promise<T> => {
        console.log("option", option);
        if (option.ignoreError != true) {
          httpConfig.errorHandler(err);
        }
        return Promise.reject(err);
      });
  }
  return { service, request };
}
export function createGET(request: (option: RequestConfig) => Promise<any>): (url: string, data?: any, config?: RequestConfig) => Promise<any> {
  return function get(url: string, data?: any, config?: RequestConfig): Promise<any> {
    data = handleParamsFn(data);
    const option = {
      url,
      method: "get" as Method,
      params: data || {},
    };
    extend(option, config);
    return request(option);
  };
}
export function createGETExFile(request: (option: RequestConfig) => Promise<any>): (url: string, data?: any, config?: RequestConfig) => Promise<any> {
  return function get(url: string, data?: any, config?: RequestConfig): Promise<any> {
    data = handleParamsFn(data);
    const option = {
      url,
      method: "get" as Method,
      params: data || {},
      responseType: "blob" as any,
    };
    extend(option, config);
    return request(option);
  };
}
export function createPostExFile(request: (option: RequestConfig) => Promise<any>): (url: string, data?: any, config?: RequestConfig) => Promise<any> {
  return function post(url: string, data?: any, config?: RequestConfig): Promise<any> {
    data = handleParamsFn(data);
    const option = {
      url,
      method: "post" as Method,
      data: data || {},
      responseType: "blob" as any,
    };
    extend(option, config);
    return request(option);
  };
}
export function createGETForm(request: (option: RequestConfig) => Promise<any>): (url: string, data?: any, config?: RequestConfig) => Promise<any> {
  return function get(url: string, data?: any, config?: RequestConfig): Promise<any> {
    const option = {
      url,
      method: "get" as Method,
      data: qs.stringify(data || {}),
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    };
    extend(option, config);
    return request(option);
  };
}

export function createPOST(request: (option: RequestConfig) => Promise<any>): (url: string, data?: any, config?: RequestConfig) => Promise<any> {
  return function post(url: string, data?: any, config?: RequestConfig): Promise<any> {
    data = handleParamsFn(data);
    const option = {
      url,
      method: "post" as Method,
      data: data || {},
    };
    extend(option, config);
    return request(option);
  };
}

export function createPOSTForm(request: (option: RequestConfig) => Promise<any>): (url: string, data?: any, config?: RequestConfig) => Promise<any> {
  return function post(url: string, data?: any, config?: RequestConfig): Promise<any> {
    const option = {
      url,
      method: "post" as Method,
      data: qs.stringify(data || {}),
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    };
    extend(option, config);
    return request(option);
  };
}
export function createPOSTFormData(request: (option: RequestConfig) => Promise<any>): (url: string, data?: any, config?: RequestConfig) => Promise<any> {
  return function post(url: string, data?: any, config?: RequestConfig): Promise<any> {
    const option = {
      url,
      method: "post" as Method,
      data: data || {},
      headers: { "Content-Type": "multipart/form-data" },
    };
    extend(option, config);
    console.log(option);
    return request(option);
  };
}

export function createPUT(request: (option: RequestConfig) => Promise<any>): (url: string, data?: any, config?: RequestConfig) => Promise<any> {
  return function put(url: string, data?: any, config?: RequestConfig): Promise<any> {
    data = handleParamsFn(data);
    const option = {
      url,
      method: "put" as Method,
      data: data || {},
    };
    extend(option, config);
    return request(option);
  };
}
export function createPUTForm(request: (option: RequestConfig) => Promise<any>): (url: string, data?: any, config?: RequestConfig) => Promise<any> {
  return function put(url: string, data?: any, config?: RequestConfig): Promise<any> {
    const option = {
      url,
      method: "put" as Method,
      data: qs.stringify(data || {}),
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    };
    extend(option, config);
    return request(option);
  };
}
export function createDEL(request: (option: RequestConfig) => Promise<any>): (url: string, data?: any, config?: RequestConfig) => Promise<any> {
  return function del(url: string, data?: any, config?: RequestConfig): Promise<any> {
    data = handleParamsFn(data);
    const option = {
      url,
      method: "delete" as Method,
      params: data || {},
    };
    extend(option, config);
    return request(option);
  };
}
export function createPATCH(request: (option: RequestConfig) => Promise<any>): (url: string, data?: any, config?: RequestConfig) => Promise<any> {
  return function patch(url: string, data?: any, config?: RequestConfig): Promise<any> {
    data = handleParamsFn(data);
    const option = {
      url,
      method: "patch" as Method,
      data: data || {},
      headers: { "Content-Type": "x-www-form-urlencoded" },
    };
    extend(option, config);
    return request(option);
  };
}
